import { useSelector } from 'react-redux';

export function useCurrency(priceUSD) {
    const selectedCurrency = useSelector((state) => state.currencyReducer.currenciesRates);

    const price = Number(priceUSD);

    if (!selectedCurrency?.symbol || selectedCurrency?.symbol === 'USD' || isNaN(price)) {
        return { price: price ? price.toFixed(2) : '0.00', symbol: '$', code: 'USD' };
    }

    const rate = Number(selectedCurrency.sell);
    if (!rate || isNaN(rate) || rate === 0) {
        return { price: price.toFixed(2), symbol: '$', code: 'USD' };
    }

    const converted = price / rate;

    return {
        price: Number(converted.toFixed(2)),
        symbol: selectedCurrency.symbol === 'NGN' ? '₦' : selectedCurrency.symbol,
        code: selectedCurrency.code || selectedCurrency.symbol,
    };
}

export function useUSDToNairaCurrency(priceUSD) {
    const currencies = useSelector((state) => state.currencyReducer.currencies);
    const ngnEntry = currencies?.find((c) => c?.symbol === 'NGN');
    const ngnRate = Number(ngnEntry?.sell) || 0;

    if (!ngnRate) {
        return { price: Number(priceUSD).toFixed(2), symbol: '₦', code: 'NGN' };
    }

    return {
        price: Number((Number(priceUSD) / ngnRate).toFixed(2)),
        symbol: '₦',
        code: 'NGN',
    };
}

export function useNairaToUSDToCurrency(priceNGN) {
    const currencies = useSelector((state) => state.currencyReducer.currencies);
    const ngnEntry = currencies?.find((c) => c?.symbol === 'NGN');
    const ngnRate = Number(ngnEntry?.sell) || 0;

    const priceUSD = ngnRate > 0 ? Number(priceNGN) * ngnRate : Number(priceNGN);

    return useCurrency(priceUSD);
}

export function useGetRateByCurrency(currencySymbol) {
    const currencies = useSelector((state) => state.currencyReducer.currencies);
    if (!currencySymbol) return 1;
    return Number(currencies?.find((c) => c.symbol === currencySymbol)?.sell) || 1;
}

export function priceToUSD(price, rate) {
    return parseFloat(price * rate);
}

export function usdToCurrency(price, rate) {
    return Number(price / rate);
}
